var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AtomButtonDropdown',{class:_vm.classes,attrs:{"auto-width":_vm.autoWidth,"items":_vm.items,"initial-index":_vm.initialCity},on:{"select":_vm.onCitySelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }